import { NotificationLoyaltyType } from '../../notification-loyalty-type.enum';
import { EntityNotificationGroupItem } from './entity-notification-group-item.model';

export interface EntityNotificationGroup {
  EntityNotificationGroupId: number;
  NotificationGroupId: number;
  Active: boolean;
  DisplayText: string;
  Description: string;
  NotificationGroupItems: EntityNotificationGroupItem[];
}

export function GroupHasLoyaltyTypeAndIsActive(
  group: EntityNotificationGroup,
  loyaltyActionId: NotificationLoyaltyType
): boolean {
  if (!group.NotificationGroupItems || group.NotificationGroupItems.length === 0) {
    return false;
  }

  const foundItem = GetItemByLoyaltyId(group.NotificationGroupItems, loyaltyActionId);
  if (foundItem) {
    if (group.Active && foundItem.Active) {
      return true;
    } else if (!group.Active && foundItem.Active && foundItem.Critical) {
      return true;
    }
  }
  return false;
}

function GetItemByLoyaltyId(
  groupItems: EntityNotificationGroupItem[],
  loyaltyActionId: NotificationLoyaltyType
): EntityNotificationGroupItem | undefined {
  for (const item of groupItems) {
    if (item.LoyaltyActionId === loyaltyActionId) {
      return item;
    }
  }
  return undefined;
}
